var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "component-select" }, [
    _c(
      "div",
      { staticClass: "component-select-wrap" },
      [
        _c("div", { staticClass: "sybold font16 choiceBtn z2 noevent" }, [
          _vm._v(_vm._s(_vm.text))
        ]),
        _c(
          "el-select",
          {
            staticClass: "el-select overlay",
            attrs: {
              value: _vm.inputVal,
              placeholder: "请选择",
              disabled: _vm.disable
            },
            on: {
              change: _vm.onSelectChange,
              "visible-change": function($event) {
                return _vm.visibleChagneHandler($event)
              }
            }
          },
          _vm._l(_vm.options, function(item, index) {
            return _c("el-option", {
              key: "option_" + index,
              staticClass: "w-normal",
              attrs: { label: item.label, value: item.value }
            })
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }